<!-- LANDING CAROUSEL STARTS -->
<section class="landing-area">
    <div class="container-xxl">
        <div class="row">
            <div class="swiper main-slider px-0">
                <div class="swiper-wrapper">
         
                    <div *ngFor="let loopBannerRes of this.bannerResult"  class="swiper-slide animeslide-slide">
                       
                        <div class="container-xxl position-relative landing" *ngIf="loopBannerRes.bannerDesignType==1">
                            <div class="row">
                                <!-- Text -->
                                <div class="col-lg-12 bg-green-landscape" >
                                    <div class="banner-description-landscape">
                                      
                                        <h1 data-animate="bottom" class="screen-reader text-head-bg animeslide-heading-1" [innerHTML]="encDec.decodeHtml( language == 'English' ? loopBannerRes.titleInEnglish: loopBannerRes.titleInHindi)">
                                        </h1>
                                        <h1 data-animate="bottom" class="screen-reader text-head-bg animeslide-heading-2" [innerHTML]="encDec.decodeHtml( language == 'English' ? loopBannerRes.snippetInEnglish: loopBannerRes.snippetInHindi)">
                                        </h1> 
                                    </div>
                                    <div class="landscape-overlay desktop-view" style="background-image: url({{backendUrl}}storage/app/uploads/{{loopBannerRes.bannerImage}});">
                                    </div>
                                    <div class="landscape-overlay mobile-view" style="background-image: url({{backendUrl}}storage/app/uploads/{{loopBannerRes.bannerImageMobile}});">

                                        
                                    </div>
                                </div>
                            </div>
                        </div>

 
                        <div class="container-xxl position-relative landing" *ngIf="loopBannerRes.bannerDesignType==2">
                            <div class="row"> 
                                <!-- Text -->
                                <div class="col-lg-6 pe-lg-5 bg-green"> 
                                    <div class="slider-mask animeslide-mask" data-animate="bottom">
                                        <div class="mask-one"></div>
                                    </div>
                                    <div class="banner-description">
                                        <h1 data-animate="bottom" class="screen-reader animeslide-heading" [innerHTML]="encDec.decodeHtml(language == 'English' ?loopBannerRes.titleInEnglish: loopBannerRes.titleInHindi)">
                                        </h1>
                                        <p data-animate="bottom" class="screen-reader animeslide-desc font-adjust" [innerHTML]="encDec.decodeHtml(language == 'English' ?loopBannerRes.snippetInEnglish: loopBannerRes.snippetInHindi)">FCI </p>
                                        <div data-animate="bottom" class="animeslide-btn" *ngIf="loopBannerRes.readmorePageLin!=''">
                                            <button (click)="goToContentPage(loopBannerRes.readmoreMenu)" [attr.title]="language=='English'?'Click here to read more':'आगे पढने के लिए यहाँ क्लीक करें'" type="button"
                                            class="btn btn-outline-light btn-lg px-4 py-2 mt-3 screen-reader">{{ 'ReadMore' | translate  }}</button>
                                        </div> 
                                    </div>
                                    <div class="overlay" style="background-image: url({{backendUrl}}storage/app/uploads/{{loopBannerRes.bannerImage}});">
                                    </div>
                                </div>
                                <!-- Image -->
                                <div class="col-lg-6 px-0">
                                    <div class="overflow-hidden">
                                        <div class="banner-image"
                                            style="background-image: url({{backendUrl}}storage/app/uploads/{{loopBannerRes.bannerImage}});"></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- LANDING CAROUSEL ENDS -->
<div id="section-New"></div>
<!-- SLIDER THUMBNAILS WITH NAVIGATION - STARTS -->
<div class="thumbnails-box">
    <div class="container-xxl">
         <div class="row">
            <div class="col-lg-9 px-0">
            <div thumbsSlider="" class="swiper thumbnails">
                <div class="swiper-wrapper">
                    <div class="swiper-slide"  *ngFor="let loopBannerNavRes of this.bannerResult">
                        <div class="thumbnail-item">
                            <i [class]="loopBannerNavRes.sectionClassImage"></i>
                            <div class="dept-name screen-reader">
                                {{getMenuname(loopBannerNavRes.jsonOptTxtDetails,"VCHBANNERSEC")}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="col-lg-3 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-start align-items-center statistical-data"  [routerLink]='["/statistical-data/wheat"]'>
                <a href="javascript:void();" >
                    <div class="statistical-data-item ps-xl-4">
                        <i class="icon-fci-statisticalData"></i>
                        <div class="dept-name screen-reader">
                           {{ 'StatisticalData' | translate }}
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
<!-- SLIDER THUMBNAILS WITH NAVIGATION - ENDS -->